import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor per aggiungere il token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor per gestire errori di autenticazione
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (username, password) => 
    api.post('/auth/login', { username, password }),
  logout: () => 
    api.post('/auth/logout'),
  getCurrentUser: () => 
    api.get('/auth/me'),
};

// Users API
export const usersAPI = {
  getAll: () => 
    api.get('/users'),
  getById: (id) => 
    api.get(`/users/${id}`),
  create: (userData) => 
    api.post('/users', userData),
  update: (id, userData) => 
    api.put(`/users/${id}`, userData),
  delete: (id) => 
    api.delete(`/users/${id}`),
};

// Analytics API
export const analyticsAPI = {
  getDashboard: () => 
    api.get('/analytics/dashboard'),
  getDailyStats: (days = 30) => 
    api.get(`/analytics/daily-stats?days=${days}`),
  getStatsByProduct: () => 
    api.get('/analytics/by-product'),
  getStatsByInterface: () => 
    api.get('/analytics/by-interface'),
  getChats: (params) => 
    api.get('/analytics/chats', { params }),
  getChatDetail: (chatId) => 
    api.get(`/analytics/chats/${chatId}`),
  getErrors: (params) => 
    api.get('/analytics/errors', { params }),
  getCosts: (period = 'daily', days = 30) =>
    api.get(`/analytics/costs?period=${period}&days=${days}`),
  getResponseTimes: (period = 'daily', days = 30) =>
    api.get(`/analytics/response-times?period=${period}&days=${days}`),
};

export default api;

